/**
 * Generate a strong random password
 * @param {Object} options - Password generation options
 * @param {number} options.length - Password length
 * @param {boolean} options.uppercase - Include uppercase letters
 * @param {boolean} options.lowercase - Include lowercase letters
 * @param {boolean} options.numbers - Include numbers
 * @param {boolean} options.symbols - Include symbols
 * @returns {string} - Generated password
 */
export const generateStrongPassword = (options = {}) => {
    const {
      length = 12,
      uppercase = true,
      lowercase = true,
      numbers = true,
      symbols = true,
    } = options;
    
    const uppercaseChars = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // Excluding similar chars like I, O
    const lowercaseChars = 'abcdefghijkmnpqrstuvwxyz'; // Excluding similar chars like l, o
    const numberChars = '23456789'; // Excluding 0, 1
    const symbolChars = '!@#$%^&*()-_=+[]{}|;:,.<>?';
    
    let chars = '';
    if (uppercase) chars += uppercaseChars;
    if (lowercase) chars += lowercaseChars;
    if (numbers) chars += numberChars;
    if (symbols) chars += symbolChars;
    
    if (chars.length === 0) {
      chars = lowercaseChars + numberChars; // Fallback
    }
    
    // Ensure at least one character from each selected set
    let password = '';
    
    if (uppercase) {
      password += uppercaseChars.charAt(Math.floor(Math.random() * uppercaseChars.length));
    }
    
    if (lowercase) {
      password += lowercaseChars.charAt(Math.floor(Math.random() * lowercaseChars.length));
    }
    
    if (numbers) {
      password += numberChars.charAt(Math.floor(Math.random() * numberChars.length));
    }
    
    if (symbols) {
      password += symbolChars.charAt(Math.floor(Math.random() * symbolChars.length));
    }
    
    // Fill the rest with random characters
    for (let i = password.length; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    
    // Shuffle the password characters
    password = password.split('').sort(() => 0.5 - Math.random()).join('');
    
    return password;
  };
  